<app-navbar />

<div class="page-body">
  <router-outlet />
</div>
